import { useApi } from '../useApi';

export function useGetFile(controlId: string) {
  const getApi = useApi();

  const getControl = async () => {
    const api = await getApi();

    const res = await api.controlsGetControlFile(controlId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return res.data as any;
  };

  return getControl;
}
